const actions = {
  getDownload: async (
    context,
    { page, current_page, data_inicial, data_final, pessoa }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`central-download`, {
      params: {
        page,
        current_page,
        data_inicial,
        data_final,
        pessoa,
      },
    });

    return response;
  },
};

export const ctd = {
  namespaced: true,
  actions,
};
